import type { AuthProfile } from '../schemas/auth.schema';

/** What to call the signed-in user. Staff may have no name; every account has a login. */
export function accountName(user: Pick<AuthProfile, 'name' | 'email' | 'mobile'>): string {
  return user.name ?? user.email ?? user.mobile ?? 'You';
}
